import { MOBILE_MAX } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

export interface Image {
  alt: string;
  mobileFullScreenImageJpgUri: string;
  mobileFullScreenImageWebpUri: string;
  desktopFullScreenImageJpgUri: string;
  desktopFullScreenImageWebpUri: string;
}

const StyledImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  vertical-align: middle;
`;

const StyledPicture = styled.picture`
  width: 100%;
`;

interface ImageDangerouslySetClassNames {
  img?: string;
}

interface ImageProps {
  className?: string;
  dangerouslySetClassnames?: ImageDangerouslySetClassNames;
  mediaItem: Image;
  loading?: 'lazy' | 'eager';
}

export const Image: FunctionComponent<ImageProps> = ({
  className,
  dangerouslySetClassnames,
  mediaItem: {
    desktopFullScreenImageJpgUri,
    mobileFullScreenImageJpgUri,
    desktopFullScreenImageWebpUri,
    mobileFullScreenImageWebpUri,
    alt,
  },
  loading = 'lazy',
}) => {
  return (
    <>
      <StyledPicture className={className}>
        <source
          srcSet={desktopFullScreenImageWebpUri}
          media={`(min-width: ${MOBILE_MAX}px)`}
          type="image/webp"
        />
        <source srcSet={mobileFullScreenImageWebpUri} type="image/webp" />
        <source
          srcSet={desktopFullScreenImageJpgUri}
          media={`(min-width: ${MOBILE_MAX}px)`}
          type="image/jpeg"
        />
        <StyledImage
          className={dangerouslySetClassnames?.img}
          loading={loading}
          src={mobileFullScreenImageJpgUri}
          alt={alt}
        />
      </StyledPicture>
    </>
  );
};
